<script setup lang="ts">
import { computed } from "vue";
import { tryUseDialogLayer } from "../../composables/Dialog/useDialogLayer";
import VDivider from "../Divider/VDivider.vue";

defineSlots<{
  default?: () => unknown
}>();

const layer = tryUseDialogLayer();

const rootClass = computed(() => {
  if (layer?.paddingless) {
    return "w-full p-5";
  }
  return "w-full mt-5";
});
</script>

<template>
  <div :class="rootClass">
    <VDivider no-margins class="w-full" />
    <div class="flex justify-between pt-5">
      <slot />
    </div>
  </div>
</template>
